import { JSX } from 'react';
import { Layout } from '../../components/core';
import { PageContent, PageCrisis } from '../../components/page';
import { NoSelfReferContent } from '../../components/therapy/NoSelfReferContent';
import { useTitle } from '../../utils/useTitle';

export const TherapyNoSelfReferErrorPage = (): JSX.Element => {
  useTitle('Therapy Eligibility');

  return (
    <PageContent testID="therapy-no-self-refer-page">
      <Layout.VStack space={7}>
        <NoSelfReferContent showReturnButton={true} testIdPrefix="therapy-no-self-refer" />
        <PageCrisis />
      </Layout.VStack>
    </PageContent>
  );
};
